module.exports = __webpack_public_path__ + "static/media/administracion.e8436f9e.svg";